module.exports = __webpack_public_path__ + "3cf3d8c155509eb21c7cb2847682836a.jpg";